(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7013],{

/***/ 69519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/depop-feedback/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-05-15",
      tag: "Depop",
      title: "How Depop Feedbacks Can Boost Sales and Leverage Credibility",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Feedback is a powerful tool that many sellers utilize to improve their business and leverage their sales and credibility to potential buyers. As a seller, having consistent positive feedback on your store is a must if you want to amass a loyal following of buyers that are satisfied with your service and products enough to attract other potential buyers. Buyers want to know that they are in good hands and have a hassle-free transaction. On Depop, sellers and buyers will be asked to score their transaction from 1 to 5 stars and provide a note when they leave feedback."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["As mentioned, giving feedback allows buyers and sellers to review their transaction's experience honestly and fairly, as long as the feedback does not violate the Depop policies. It's crucial to note that your rating is based on several reviews collected over a specific period, so it's natural to vary.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "This article will discuss how feedback is an excellent learning tool that allows you to improve as a seller and what you can do to combat untrue or unfair feedback."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Tips on earning a 5-star feedback"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Some tried and true tips on how to earn consistent 5-star feedback from buyers are to ensure that they receive their orders in a timely manner by having clear communication with them by setting the expectations. It also pays to be diligent and assist them with quality customer service that involves answering their queries and assisting them when they need help. For example, they might ask how to leave feedback on your profile- this is an extra service that you can do by showing them how."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to leave feedback on Depop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Any online marketplace needs to make leaving feedback as seamless and convenient as possible. And with this, Depop has made it easy to provide feedback. All that the user has to do is to simply:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to the profile where they would like to leave feedback."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Look through the receipts."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Tap the purchase or sale for which you want to offer feedback."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "And tap your feedback."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to delete feedback"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "As with anything that we post online, we may have instances wherein we want to edit or delete it due to a change of mind. This isn't a problem when leaving feedback on Depop. If you want to remove feedback you've left, all you have to do is simply follow these steps:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Go to Profile and use the Receipts icon to find the feedback in your Purchased or Sold items list."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Then tap on the feedback you left that you would like to delete"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Finally, to permanently delete your feedback, simply use the trash can symbol in the top right corner of the screen."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What to do if you were left unfair feedback"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It's not uncommon that there are instances wherein sellers will be given unfair feedback. So in the case that you believe you have been given unfair feedback, the first step is to contact the user and work out a solution with them. See if they can change their comments or if they can erase them."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "What to do if you can't resolve the feedback you've been left"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "If you cannot resolve the feedback you have received, Depop can review it with you. All you have to do is include evidence supporting why you believe they should remove the feedback."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Conditions where Depop can remove the feedback"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Although Depop supports sellers in combating unjust feedback, they also have set limitations in resolving feedback. As a seller, it is important to keep in mind that Depop can't remove feedback with a rating of 3 stars or higher unless it falls into one of the following categories:"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Revenge feedback, meaning feedback that is left after a suitable amount of time has passed since the transaction."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Any abusive or disparaging language directed at another user includes homophobia, transphobia, sexism, racism or privilege insults, body or poverty shaming, etc."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Depop can confirm that the feedback is false or untrue at the time of writing."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Getting more things done with automation"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "At the end of the day, feedback is powerful in measuring the credibility of your business for buyers. Staying on top of your feedback and business operations is difficult, especially if you wear many hats in your business. Hence, having an automation tool to help you manage your business is beneficial."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "One tool that is guaranteed to help you navigate through this is OneShop. It is an automation tool that helps cross-list from Depop to other platforms to grow your business. And it's not just limited to Depop; you can also use OneShop if you sell on Poshmark to help you automate your daily tasks such as liking, following, sending offers to likers, and much more!"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Never lose track and focus on nailing your customer service and assisting your buyers in getting consistently good reviews. Start your ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "7-day free trial"
        }), " today with no risks involved and get set up within three minutes. See how this automation service can improve your reselling operations.", ' ']
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/depop-feedback.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "How Depop Feedbacks Can Boost Sales and Leverage Credibility"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "The way to get potential buyers to make a purchase decision is to show them how reliable you are. And with this, it is critical to ensure that the process of leaving and deleting feedback on Depop is as convenient as can be. Learn how it works and get tips to help you gain 5-star ratings."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/depop-feedback"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/depop-feedback"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "How Depop Feedbacks Can Boost Sales and Leverage Credibility"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "The way to get potential buyers to make a purchase decision is to show them how reliable you are. And with this, it is critical to ensure that the process of leaving and deleting feedback on Depop is as convenient as can be. Learn how it works and get tips to help you gain 5-star ratings."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-05-15T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-05-15T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Depop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 34338:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/depop-feedback",
      function () {
        return __webpack_require__(69519);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(34338); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);